import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { ProjectModel } from '@models/Models';
import useProject from '@hooks/useProject';
import { ProjectStatus } from '@models/Enums';
import useExcel from '@hooks/useExcel';
import ArchivedProject from './components/ArchivedProject';

const Archiv: React.FC = () => {
    const { getProjectsByStatus, deleteProject } = useProject();
    const [projects, setProjects] = useState<ProjectModel[]>([]);
    const [loading, setLoading] = useState(false);
    const { exportProject } = useExcel();

    useEffect(() => {
        projectsGetter();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const projectsGetter = async () => {
        try {
            const projectsResponse = await getProjectsByStatus(ProjectStatus.ARCHIVED);

            if(!projectsResponse.success){
                console.error('Error fetching projects:', projectsResponse.message);
                alert(projectsResponse.message);
                return;
            }

            setProjects(projectsResponse.data as ProjectModel[]);
        }catch (error) {
            console.error('Error fetching projects:', error);
        }
    }

    const handleExportToExcel = async (projectId: string) => {
        try {
            setLoading(true);

            await exportProject(projectId);
        } catch (error) {
            console.error('Failed to export to Excel:', error);
            alert('Fehler beim Exportieren in Excel');
        }finally {
            setLoading(false);
        }
    };

    const handleDeleteProject = async (projectId: string) => {
        const confirmDelete = window.confirm("Bist du sicher, dass du dieses Projekt löschen möchtest?");
        
        if (confirmDelete) {
            try {
                const deleteResponse = await deleteProject(projectId);
    
                if (!deleteResponse.success) {
                    console.error("Fehler beim Löschen des Projekts:", deleteResponse.message);
                    alert(deleteResponse.message);
                    return;
                }
    
                alert("Dieser Vorgang kann eine Weile dauern, daher führen wir ihn im Hintergrund aus. Sie können diese Seite verlassen und später wiederkommen.");
                projectsGetter(); // Refresh project list after deletion
            } catch (error) {
                console.error("Fehler beim Löschen des Projekts:", error);
                alert("Fehler beim Löschen des Projekts.");
            }
        }
    };

    return (
        <Container className='myCont'>
            <Row>
                <Col xs={10}>
                    <h1>Masterplattform</h1>
                    <p>Hier finden Sie alle Ihre archivierten Projekte.</p>
                </Col>
            </Row>
            <Row className='project-comp shadow myBorder'>
                <Col xs={12}>
                    {projects.map((item) => (
                        <ArchivedProject
                            key={item.id}
                            item={item}
                            loading={loading}
                            onDelete={handleDeleteProject}
                            onExport={handleExportToExcel}
                        />
                    ))}
                </Col>
                
            </Row>
        </Container>
    )
}
export default Archiv